module.exports = __webpack_public_path__ + "img/IT.6b824af0.png";